export default __webpack_public_path__ + "static/article-why-you-shouldnt-be-scared-of-credit-cards-abfe0fb0270ea0282640ffe6fedc823f.jpg";